import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { url_83 } from "../../../../../../../custom_utilities/api_services";
import useAuthUtils from "../../../../../../../hooks/auth/useAuthUtils";
import usePyqRedux from "./usePyqRedux";

export const useGetPyqTopicList = () => {
  const { startLoading, finishLoading, classId, courseId } = useAuthUtils();
  const { pyqMainCurrentTab, pyqSubCurrentTab } = usePyqRedux();

  const fetchPyqTopicList = async () => {
    try {
      startLoading();
      const response = await axios.post(url_83, {
        class_id: classId,
        course_id: courseId,
      });

      if (response.data.status === 200) {
        console.log(response.data.data);
        return response?.data?.data?.subject;
      }

      return [];
    } catch (error) {
      console.log(error);
      return [];
    } finally {
      finishLoading();
    }
  };

  return useQuery({
    queryKey: ["pyq-topic-list", pyqMainCurrentTab, pyqSubCurrentTab],
    queryFn: fetchPyqTopicList,
  });
};
